<template>
	<div class="header no-print">
		<div class="header-page">
			<div
				class="header-title"
				:style="{cursor: subMenuActive ? 'pointer' : 'default'}"
				@click.prevent="showSubMenu()"
			>
				<div class="header-icon">
					<slot name="icon" />
				</div>
				<div>
					<h3 style="margin-top: 0">{{ title | upper }}</h3>
					<h4 style="margin-bottom: 0">{{ subTitle | upper }}</h4>
				</div>
				<div v-if="subMenuActive" style="margin-left: 10px">
					<IconArrowDown size="lg" />
				</div>
			</div>
			<div>
				<slot name="actions" v-if="!mobile" />
				<ButtonPrint size="lg" v-if="showPrint" @click="$emit('print')" />
				<ButtonReturn size="lg" v-if="showReturn" @click="$emit('voltar')" />
			</div>
		</div>
		<div v-if="mobile">
			<Divider />
			<slot name="actions" />
		</div>
		<Divider type="primary" style="margin: 10px 0" />
	</div>
</template>

<script>
import IconSolicitacao from '../icon/IconSolicitacao.vue'
import ButtonReturn from '../button/ButtonReturn.vue'
import ButtonPrint from '../button/ButtonPrint.vue'
import Divider from '../layout/Divider.vue'
import IconArrowDown from '../icon/IconArrowDown.vue'
export default {
	components: {
		IconSolicitacao,
		ButtonReturn,
		ButtonPrint,
		Divider,
		IconArrowDown
	},
	props: {
		title: {
			type: String
		},
		subTitle: {
			type: String
		},
		showReturn: {
			type: Boolean
		},
		showPrint: {
			type: Boolean
		},
		subMenuActive: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		mobile() {
			return this._width <= 1024
		}
	},

	methods: {
		showSubMenu() {
			if (this.subMenuActive) {
				this.$emit('show-sub-menu')
			}
		}
	}
}
</script>

<style scoped>
.header-page {
	justify-content: space-between;
	display: flex;
	align-items: center;
}
.header-title {
	display: flex;
	align-items: center;
}
.header-icon {
	color: #2196f3;
	font-size: 38px;
	margin-right: 15px;
	display: flex;
}
</style>